import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=23ae2baf&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=ts"
export * from "./Calendar.vue?vue&type=script&lang=ts"
import style0 from "./Calendar.vue?vue&type=style&index=0&id=23ae2baf&lang=scss"
import style1 from "./Calendar.vue?vue&type=style&index=1&id=23ae2baf&scoped=true&lang=scss"
import style2 from "./Calendar.vue?vue&type=style&index=2&id=23ae2baf&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ae2baf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23ae2baf')) {
      api.createRecord('23ae2baf', component.options)
    } else {
      api.reload('23ae2baf', component.options)
    }
    module.hot.accept("./Calendar.vue?vue&type=template&id=23ae2baf&scoped=true", function () {
      api.rerender('23ae2baf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/Calendar.vue"
export default component.exports